import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { IUVSection } from '../components/IUVSection';
import { IncludesSection } from '../components/IncludesSection';
import { LearningSection } from '../components/LearningSection';
import { InsideSection } from '../components/InsideSection';
import { ResultsSection } from '../components/ResultsSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-bg-primary" data-id="element-471">
      <Hero data-id="element-472" />
      <ProblemSection data-id="element-473" />
      <IUVSection data-id="element-474" />
      <IncludesSection data-id="element-475" />
      <LearningSection data-id="element-476" />
      <InsideSection data-id="element-477" />
      <ResultsSection data-id="element-478" />
      <FAQSection data-id="element-479" />
      <FinalCTASection data-id="element-480" />
      <Footer data-id="element-481" />
    </div>;
}